import React from "react";
import { Formik } from "formik";
import { MappedInput } from "@bit/the-glue.frontendcomponents.input";
import { crsKeyFormSchema } from "../../../helpers/schemas";

export const CRSKeyForm = ({ handleSubmit, onClose }) => {
  const initialValues = {
    api_key: "",
  };

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={initialValues}
      validationSchema={crsKeyFormSchema}
    >
      {({ handleSubmit, isSubmitting }) => (
        <div className="py-10">
          <h4 className="mb-10 text-center">
            <strong>Provide API Key</strong>
          </h4>
          <div className="d-flex">
            <div className="w-100">
              <MappedInput name="api_key" label="API Key" data-testid="capi_keylient_id" />
            </div>
          </div>
          <div className="d-flex justify-content-end mt-15 mb-5">
            <button onClick={onClose} className="btn btn-white mr-3">
              <strong>Cancel</strong>
            </button>
            <button
              onClick={handleSubmit}
              className=" py-3 px-5 text-uppercase text-primary bg-primary text-white border border-primary rounded"
              disabled={isSubmitting}
              type="submit"
            >
              <strong>Submit</strong>
            </button>
          </div>
        </div>
      )}
    </Formik>
  );
};
